import axios from 'axios';

import {
    API_BASE_URL,
    API_URL_GET_DOCUMENTS_LIST,
    API_URL_UPLOAD_DOCUMENT
} from '../constants';

export default class DocumentsService {
	static instance;

	static getInstance() {
		if (!DocumentsService.instance) {
			DocumentsService.instance = new DocumentsService();
		}

		return DocumentsService.instance;
	}

    async list(params = {}){
        const response = await axios.get(API_URL_GET_DOCUMENTS_LIST, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data || {}
    }

    async uploadDocument(payload = {}){
        const response = await axios.post(`${API_URL_UPLOAD_DOCUMENT}`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                'Content-Type': 'multipart/form-data'
            }
        });
  
        return response.data.data;
    }

    async updateDocument(documentId, payload = {}){
        const response = await axios.post(`${API_BASE_URL}/asset_document/${documentId}/update_attachment`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
                'Content-Type': 'multipart/form-data'
            }
        });
  
        return response.data.data;
    }

    async deleteDocument(id){
        const response = await axios.delete(`${API_BASE_URL}/asset_document/${id}/delete_attachment`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
  
        return response.data.data;
    }
}
